export var VERSION = '2.4.0';
//# sourceMappingURL=version.js.map